import { render, staticRenderFns } from "./userCustomTemplate.vue?vue&type=template&id=e5c4be84&scoped=true"
import script from "./userCustomTemplate.vue?vue&type=script&lang=js"
export * from "./userCustomTemplate.vue?vue&type=script&lang=js"
import style0 from "./userCustomTemplate.vue?vue&type=style&index=0&id=e5c4be84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c4be84",
  null
  
)

export default component.exports